/**
 * The initial value of Symbol.unscopables is the well-known symbol @@unscopables
 * https://tc39.es/ecma262/#sec-symbol.unscopables
 */
export const symbolUnscopables = () => Symbol("Symbol.unscopables");
